import { mpEventInfo } from '@/constant'
import type { ParentsAppNotice } from '@/dto'
import type { PageQueryString, Pagination } from '@/types/common'
import type { StrapiArrayResponse, StrapiSingleResponse } from '@/types/common/api'
import maxios from '@/utils/axios/maxios'
import strapi from '@/utils/axios/strapi'

type ParentsAppNoticesResponse = Pagination<res.ParentsAppNotice[]>

// 공지 API
const noticeApi = {
  /* 매쓰플랫-기관*/
  // 공지(기관) 가져오기
  async getAcademies(params) {
    const res = await strapi.get<StrapiArrayResponse<res.AcademyNotice>>(`/mathflat-notices`, {
      params: {
        ...params,
        mp_event_name: mpEventInfo.공지사항,
      },
    })
    return res.data
  },
  // 팝업
  /** @deprecated */
  getPopup: async (params) => {
    return await strapi.get<StrapiArrayResponse<res.Popup>>('/mathflat-popups', {
      params: {
        ...params,
        mp_event_name: mpEventInfo.일반팝업,
      },
    })
  },
  // 업데이트 사항
  /** @deprecated */
  getUpdateNotice: async (params) => {
    return await strapi.get<StrapiArrayResponse<res.UpdateNotice>>('/mathflat-update-notices', {
      params: {
        ...params,
        mp_event_name: mpEventInfo.이달의업데이트팝업,
      },
    })
  },
  // 알림판
  getNoticeBoard: async (params) => {
    return await strapi.get<StrapiArrayResponse<res.NoticeBoard>>('/mathflat-notices-board', {
      params: {
        ...params,
        mp_event_name: mpEventInfo.이달의업데이트팝업,
      },
    })
  },

  // 온보딩 팝업
  getOnboardingPopup: async (params) => {
    return await strapi.get<StrapiArrayResponse<res.OnboardingPopup>>(
      '/mathflat-onboarding-popups',
      {
        params,
      },
    )
  },
  async getBanner(params) {
    return await strapi.get<StrapiArrayResponse<res.Banner>>('/mathflat-banners', { params })
  },

  getUpdatedContents: async () => {
    return await strapi.get<StrapiArrayResponse<res.UpdatedContents>>('/updated-contents')
  },

  /* 기관-학부모 */
  // 공지(학부모) 생성하기
  postParentsAppNotice(parentsAppNotice: req.ParentsAppNotice) {
    return maxios.post('/notices/parents', parentsAppNotice, {
      params: { mp_event_name: mpEventInfo.학부모앱공지사항등록 },
    })
  },
  // 공지(학부모) 가져오기
  getParentsAppNotices(pageQueryString: PageQueryString) {
    return maxios.get<ParentsAppNoticesResponse>(`/notices/parents${pageQueryString}`, {
      params: { mp_event_name: mpEventInfo.학부모앱공지사항조회 },
    })
  },
  // 특정 공지(학부모) 변경하기
  putParentsAppNotice(id: ParentsAppNotice['id'], parentsAppNotice: req.ParentsAppNotice) {
    return maxios.put(`/notices/parents/${id}`, parentsAppNotice, {
      params: { mp_event_name: mpEventInfo.특정학부모앱공지사항수정 },
    })
  },
  // 특정 공지(학부모) 삭제하기
  deleteParentsAppNotice(parentsAppNoticeIds: number[]) {
    return maxios({
      url: '/notices/parents',
      method: 'DELETE',
      data: parentsAppNoticeIds,
      params: { mp_event_name: mpEventInfo.학부모앱공지사항삭제 },
    })
  },
  // 서버 점검 페이지 가져오기
  async getServerMaintenanceNotice() {
    return await strapi.get<StrapiSingleResponse<res.ServerMaintenance>>('/server-maintenance', {
      params: { mp_event_name: mpEventInfo.서버점검조회 },
    })
  },
}
export default noticeApi
